import React, { useState } from 'react';
import { Button, Snackbar } from '@mui/material';
import { Share } from '@mui/icons-material';
import { t } from '../i18n';
import { pushEvent } from '../utils/analytics';

// Shares a deep link to the current postal code. Uses the Web Share API when
// available, otherwise copies the URL to the clipboard.
const ShareButton = ({ url, title }) => {
  const [copied, setCopied] = useState(false);

  const handleShare = async () => {
    pushEvent('share_click', { share_url: url });
    if (navigator.share) {
      try {
        await navigator.share({ title, url });
        return;
      } catch {
        // user cancelled or share failed — fall through to copy
      }
    }
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      /* no-op */
    }
  };

  return (
    <>
      <Button size="small" startIcon={<Share />} onClick={handleShare} color="primary">
        {t('Share', '共有')}
      </Button>
      <Snackbar
        open={copied}
        autoHideDuration={2000}
        onClose={() => setCopied(false)}
        message={t('Link copied to clipboard', 'リンクをコピーしました')}
      />
    </>
  );
};

export default ShareButton;
